import React, { Component } from 'react';
import { Col, Form, Input, Modal, Row, Select } from 'antd';

import { queryBusinessInfo } from '@api/crm/crm';

const { Option } = Select;
const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: {},
    };
  }

  componentDidMount() {
    if (this.props.uuid) {
      this.getBusiness();
    }
  }

  getBusiness = () => {
    queryBusinessInfo({
      uuid: this.props.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          detail: res.data,
        });
      }
    });
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handleSubmit } = this.props;
    const { detail } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = {
          customer: values.customerObj.split('-')[0],
          customerName: values.customerObj.split('-')[1],
          type: values.stageObj.split('-')[0],
          percentage: values.stageObj.split('-')[1],
          prediction: values.prediction,
        };

        if (detail.uuid) {
          params.uuid = detail.uuid;
        }
        handleSubmit(params);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const ItemLayout2 = {
      labelCol: { span: 8 },
      wrapperCol: { span: 12 },
    };
    const { handleModalVisible, custom, stage } = this.props;
    const { detail } = this.state;
    const isEdit = !!detail.uuid;

    return (
      <Modal
        title={detail.uuid ? '编辑商机' : '新增商机'}
        visible
        onCancel={() => handleModalVisible(false)}
        onOk={this.submit}
      >
        <Form onSubmit={this.submit}>
          <Row>
            <Col span={24}>
              <FormItem label="客户名称" {...ItemLayout2}>
                {getFieldDecorator('customerObj', {
                  rules: [{ required: true, message: '请选择客户!' }],
                  initialValue: detail.customer ? `${detail.customer}-${detail.customerName}` : '',
                })(
                  <Select disabled={isEdit}>
                    {custom.map(item => {
                      return <Option key={`${item.uuid}-${item.name}`}>{item.name}</Option>;
                    })}
                  </Select>,
                )}
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem label="阶段类型" {...ItemLayout2}>
                {getFieldDecorator('stageObj', {
                  rules: [{ required: true, message: '请选择联阶段类型!' }],
                  initialValue: detail.type ? `${detail.type}-${detail.percentage}` : '',
                })(
                  <Select>
                    {stage.map(item => {
                      return (
                        <Option
                          key={`${item.name}-${item.percentage}`}
                        >{`${item.name}(${item.percentage}%)`}</Option>
                      );
                    })}
                  </Select>,
                )}
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem label="预测金额" {...ItemLayout2}>
                {getFieldDecorator('prediction', {
                  rules: [{ required: true, message: '请输入预测金额!' }],
                  initialValue: detail.prediction,
                })(<Input />)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(BaseForm);



// WEBPACK FOOTER //
// ./src/components/crm/business/ModalBusiness.js